export default __webpack_public_path__ + "static/media/feature5_1.cc304592.png";